import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PrimaryButton from '../PrimaryButton';
import { useStoreActions } from 'easy-peasy';

import DeleteIcon from '../../../assets/images/svg/delete-icon.svg';
import EditIcon from '../../../assets/images/svg/edit-icon.svg';
import WarningModal from '../../../assets/images/svg/warning-modal.svg';

import Modal from '../Modal_2';
import { toast } from 'react-toastify';
import Table from '../Table';

const ListMaterials = () => {
  //  Etats (données)
  const [materials, setMaterials] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [idMaterial, setIdMaterial] = useState(null);

  //  🌱🌱 init store(services)   🌱🌱
  const getListMaterial = useStoreActions((actions) => actions.middleware.SettingsMiddleware.getListMaterial);
  const deleteMaterialSettings = useStoreActions((actions) => actions.middleware.SettingsMiddleware.deleteMaterial);

  useEffect(() => {
    getMaterial();
  }, []);

  const getMaterial = async () => {
    try {
      const res = await getListMaterial();
      setMaterials(res);
    } catch (error) {
      console.log('error', error);
      toast.error('❗️ Une erreur est survenue lors du chargement de la liste des matériaux');
    }
  };

  const handleDelete = (id) => {
    setShowModal(true);
    setIdMaterial(id);
  };

  const deleteMaterial = async () => {
    try {
      const res = await deleteMaterialSettings(idMaterial);
      if (res) {
        setShowModal(false);
        getMaterial();
      }
    } catch (error) {
      console.log('error', error);
      toast.error('❗️ Une erreur est survenue lors de la suppression du matériel');
    }
  };

  return (
    <>
      <section className="md:pt-8 px-4 md:px-9">
        <div>
          <div className=" pb-4 border-b border-white-admin flex items-center justify-between ">
            <h3 className="font-semibold">Matériel</h3>
            <PrimaryButton
              title="+ Ajouter un nouveau matériel"
              style={'bg-white border border-gray-admin text-blue-admin'}
              link="add"
            />
          </div>
        </div>
        <div className="relative overflow-auto pt-14">
          <Table>
            <thead className="min-h-10">
              <tr>
                <th>Nom du matériel</th>
                <th >Nb de référence</th>
                <th>Type</th>
                <th className="flex justify-end">Actions</th>
              </tr>
            </thead>
            <tbody>
              {materials?.map((material) => {
                return (
                  <tr
                    key={material.id}
                    className="h-16 border-b border-white-admin hover:bg-blue-50 transition-all"
                  >
                    <td className="pr-14 xl:pr-20 ">{material.name}</td>
                    <td>
                      {material.references.length ? (
                        <div className="flex space-x-2">
                          <span>{material.references[0].reference.split(',').length}</span>

                          <span>
                            {material.references[0].reference.split(',').length > 1 ? 'références' : 'référence'}
                          </span>
                        </div>
                      ) : (
                        <>
                          <span> 0 </span>
                          <span>référence</span>
                        </>
                      )}
                    </td>
                    <td>{material.type || '-'}</td>
                    {material.name !== 'Climatiseur' && (
                      <td className="flex justify-end items-center pt-4 space-x-4 ">
                        <Link
                          to={`./edit/${material.id}`}
                          state={material}
                        >
                          <button className="w-8 p-2 border rounded-lg border-white-admin">
                            <img
                              src={EditIcon}
                              alt="edit icon"
                            />
                          </button>
                        </Link>
                        <button
                          className="w-8 p-2 border rounded-lg border-white-admin"
                          onClick={() => handleDelete(material.id)}
                        >
                          <img
                            src={DeleteIcon}
                            alt="delete icon"
                          />
                        </button>
                      </td>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
        <Modal isVisible={showModal}>
          <div>
            <div className="pt-5 pl-5">
              <img
                src={WarningModal}
                alt="warning icon"
              />
            </div>
            <h4 className="pl-5 pt-7">Suppresion du Matériel</h4>
            <p className="px-5 pt-2 text-sm text-gray-admin">
              Voulez-vous vraiment supprimer ce matériel de façon permanente ?
            </p>
            <div className="text-center pt-7">
              <button
                className="px-12 py-3 mr-4 font-semibold border rounded-xl text-red-error"
                onClick={() => setShowModal(false)}
              >
                Annuler
              </button>
              <button
                className="px-10 py-3 text-white bg-red-error rounded-xl"
                onClick={deleteMaterial}
              >
                Supprimer
              </button>
            </div>
          </div>
        </Modal>
      </section>
    </>
  );
};

export default ListMaterials;
